/**
 * @file navigation.ts
 * @description Constants for keyboard navigation system
 */

/**
 * CSS selector for focusable rail elements
 * Used throughout keyboard navigation system to identify rails
 */
export const RAIL_SELECTOR = '[data-rail][tabindex="0"]';

/**
 * CSS selector for focused rail elements
 */
export const FOCUSED_RAIL_SELECTOR = '[data-rail][tabindex="0"]:focus';

/**
 * Data attribute key for marking elements as navigation rails
 * Used instead of role="list" for semantic HTML compatibility
 */
export const RAIL_DATA_ATTR = "data-rail";

/**
 * Data attribute key for marking rail items
 * Used instead of role="listitem" for semantic HTML compatibility
 */
export const RAIL_ITEM_DATA_ATTR = "data-rail-item";

/**
 * CSS class for focused cards in navigation mode
 * Replaces the data-focused="true" attribute hack
 */
export const FOCUSED_CLASS = "rail-focused";
